import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminAuthGuard } from './guards/admin-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.component').then((m) => m.RegisterComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/notifications/notifications.component').then((m) => m.NotificationsComponent),
  },
  {
    path: 'admin/login',
    loadComponent: () => import('./pages/admin/admin-login/admin-login.component').then((m) => m.AdminLoginComponent),
  },
  {
    path: 'admin/rescue',
    loadComponent: () => import('./pages/admin/admin-rescue/admin-rescue.component').then((m) => m.AdminRescueComponent),
  },
  {
    path: 'admin/dashboard',
    canActivate: [adminAuthGuard],
    loadComponent: () => import('./pages/admin/admin-dashboard/admin-dashboard.component').then((m) => m.AdminDashboardComponent),
  },
  {
    path: 'books',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/books/books.component').then((m) => m.BooksComponent),
  },
  {
    path: 'books/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/books/book-detail/book-detail.component').then((m) => m.BookDetailComponent),
  },
  {
    path: 'clubs',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/clubs/clubs.component').then((m) => m.ClubsComponent),
  },
  {
    path: 'club/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/club/club.component').then((m) => m.ClubComponent),
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/profile/profile.component').then((m) => m.ProfileComponent),
  },
  { path: '**', redirectTo: '' },
];
